import { Circle, Settings, Layout, AlertTriangle } from "react-feather";

import {
  NOTIFICATION_TEMPLATE_LIST_PATH,
  APP_NOTIFICATION_LIST_PATH,
  NOTIFICATION_LOGS_LIST_PATH,
} from "@src/views/apps/platform-configuration/paths";
import { FORMS_LIST_PATH } from "@src/views/apps/form-workflow/paths";
import {
  FEATURE_TOGGLES_PATH,
  ERROR_LOGS_PATH,
} from "@src/views/apps/system/paths";
import { navPerm } from "../navPermissions";
import { PERMISSION_MODULE } from "@src/utility/permissions/modulePermissions";

export default [
  {
    header: "Platform & System",
  },
  {
    id: "platform-configuration",
    title: "Platform Configuration",
    icon: <Settings size={20} />,
    children: [
      {
        id: "notification-templates",
        title: "Notification Templates",
        icon: <Circle size={12} />,
        navLink: NOTIFICATION_TEMPLATE_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.NOTIFICATION_TEMPLATE),
      },
      {
        id: "app-notifications",
        title: "App Notifications",
        icon: <Circle size={12} />,
        navLink: APP_NOTIFICATION_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.APP_NOTIFICATION),
      },
      {
        id: "app-notification-logs",
        title: "Notification Logs",
        icon: <Circle size={12} />,
        navLink: NOTIFICATION_LOGS_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.NOTIFICATION_LOG),
      },
    ],
  },
  {
    id: "form-workflow",
    title: "Form Workflow",
    icon: <Layout size={20} />,
    children: [
      {
        id: "dynamic-form-builder",
        title: "Dynamic Form Builder",
        icon: <Circle size={12} />,
        navLink: FORMS_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.FORM),
      },
    ],
  },
  {
    id: "system-maintenance",
    title: "System Maintenance",
    icon: <AlertTriangle size={20} />,
    children: [
      {
        id: "feature-toggles",
        title: "Feature Toggles",
        icon: <Circle size={12} />,
        navLink: FEATURE_TOGGLES_PATH,
        ...navPerm(PERMISSION_MODULE.FEATURE_TOGGLE),
      },
      {
        id: "error-logs",
        title: "Error Logs",
        icon: <Circle size={12} />,
        navLink: ERROR_LOGS_PATH,
        ...navPerm(PERMISSION_MODULE.ERROR_LOG),
      },
    ],
  },
];
